<script>
    import { api_post } from "../util/api_request";
    import { time_string } from "../util/util";
    import Icon from '@iconify/svelte';
    
    export let invite;
    export let response; // Binding

    let now = new Date();
    let timestamp = new Date(invite.timestamp);
    let timestamp_relative = now - timestamp;

    let delete_invite = async () => {
        response = await api_post("/api/user/delete_invite", {
            invite_id: invite.id    
        });
    }
</script>

<div class="invite-card container" class:expired={invite.expired || invite.accepted_by}>
    <div>
        <h2>{invite.code}</h2><span title="{timestamp.toLocaleString()}" class="timestamp">{time_string(timestamp_relative)} ago</span>
    </div>
    <br>
    <div class="user-row">
        Created by
        <img src="https://mc-heads.net/avatar/{invite.created_by}/24" alt="" srcset="">
        {invite.created_by_mc_name}
    </div>
    {#if invite.accepted_by}
    <div class="user-row">
        Accepted by
        <img src="https://mc-heads.net/avatar/{invite.accepted_by}/24" alt="" srcset="">
        {invite.accepted_by_mc_name}
    </div>
    {/if}
    {#if !invite.accepted_by}
    <button on:click={delete_invite}><Icon icon="ri:delete-bin-line" width=20 /></button>
    {/if}
</div>

<style>
    .expired {
        background-color: #eee;
        color: #777;
        border-color: #cacaca;
    }

    .invite-card {
        position: relative;
        border-width: 2px;
        border-bottom-width: 4px;
        margin: 0;
    }

    .invite-card h2 {
        font-family: monospace;
        display: inline-block;
        vertical-align: middle;
        margin: 0;
    }
    
    .invite-card .timestamp, .invite-card .user-row {
        display: inline-block;
        background-color: #0000000f;
        padding: 3px 12px;
        margin-left: 10px;
        border-radius: 4px;
        vertical-align: middle;
    }

    .invite-card .card-title {
        margin-bottom: 5px;
    }

    .invite-card .user-row {
        display: block;
        width: fit-content;
        margin: 5px 0;
    }

    .invite-card .user-row * {
        vertical-align: middle;
    }

    .invite-card .user-row img {
        margin: 0 8px;
        border-radius: 3px;
    }

    button {
        position: absolute;
        right: 10px;
        bottom: 10px;
        padding: 5px;
        background-color: initial;
        color:#ce0000;
        border: 3px solid #ce0000;
        border-radius: 4px;
        cursor: pointer;
    }

    button:hover {
        background-color: #ce0000;
        color: #fff;
    }
</style>